import { Box, ImageListItem, Tooltip } from "@mui/material";
import React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";

export interface NewMessageAttachmentImageProps {
    attachment: IFileAttachment;
    onClick: (id: string) => void;
}

export const NewMessageAttachmentImage = ({ attachment, onClick }: NewMessageAttachmentImageProps) => (
    <Tooltip title={attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ", " + Base.timeToDateStr(attachment.modifyDate) + ")"}>
        <ImageListItem onClick={() => { onClick(attachment.id); }}>
            <Box component="img" src={attachment.thumbnail} alt={attachment.name} sx={{ maxHeight: "374px", maxWidth: "100%", height: "auto" }} />
        </ImageListItem>
    </Tooltip>
);